var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.diaplyName)?_c('span',{staticClass:"member-classes-period-type"},[_vm._v(" "+_vm._s(_vm.diaplyName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }